import React from 'react'
import PropTypes from 'prop-types'
import {
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  withStyles
} from '@material-ui/core'
import { Translation } from 'react-i18next'
import ApplicationRowContainer from '../../../containers/employer/applications/applicationRows.container'
import { scrollToTop } from '../../../utils/scrollTo'
import ExpandablePanel from '../../../utils/expandablePanel'
import ReactPaginate from 'react-paginate'
import mobileView from '../../../utils/mobile.utils'
import {
  employer_searchApplications,
  groupApplicationsByJob
} from '../../../utils/openForWork.utils'
import { ApplicationFilters } from '../../../utils/employer/application.utils'

/**
 *
 * @author Huong Nguyen
 */

class ApplicationsComponent extends React.Component {
  componentDidMount() {
    this.props.getAreaOfWork()
    this.props.getApplicantDetails()
    this.props.getOfferFromLightEntre()
    this.props.loadProfileStart()
    this.props.getAssignments()
    scrollToTop()
  }

  render() {
    return <Applications {...this.props} />
  }
}

const styles = (theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },
  tablecell: {
    fontWeight: 'bold',
    fontSize: '13px',
    color: 'black'
  },
  tableHead: {
    fontSize: '13px',
    fontWeight: 'bold',
    borderBottom: '1px solid gray'
  },
  searchField: {
    display: 'flex',
    flexFlow: mobileView ? 'column' : 'row',
    justifyContent: 'space-between'
  },
  filterFields: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '0px 8px 30px',
    alignItems: 'flex-end',
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0px 8px 30px',
      alignItems: 'stretch'
    }
  },
  textField: {
    marginTop: theme.spacing(3),
    border: '1px solid gray',
    fontSize: '14px'
  },
  resize: {
    fontSize: '14px'
  },
  checkbox: {
    fontSize: '14px',
    color: '#808080',
    fontWeight: 500
  },
  button: {
    margin: 15
  },
  table: {
    fontSize: '13px',
    borderTop: '2px solid #999'
  }
})

const defaultValues = {
  job_title: '',
  name: '',
  email: '',
  status: '',
  pageSize: 10,
  pinned: false
}

const statusOptions = [
  { value: '', label: '' },
  { value: 'Unprocessed application', label: 'employer.application_stt.1' },
  { value: 'Offer sent by employer', label: 'employer.application_stt.2' },
  {
    value: 'Employer rejected',
    label: 'employer.application_stt.3'
  },
  {
    value: 'Offer accepted by entrepreneur',
    label: 'employer.application_stt.4'
  },
  {
    value: 'Offer rejected by entrepreneur',
    label: 'employer.application_stt.5'
  },
  {
    value: 'Offer signed',
    label: 'employer.application_stt.7'
  }
  // {
  //   value: 'pending', // pending status is not needed as it is same Offer sent by employer
  //   label: 'employer.application_stt.6'
  // }
]

const Applications = ({ classes, applications }) => {
  const [searchApplicationValues, setSearchApplicationValues] =
    React.useState(defaultValues)
  const [page, setPage] = React.useState(0)

  const filteredApplicationRows = employer_searchApplications(
    applications,
    searchApplicationValues
  ).sort((a, b) => new Date(b.applied_date) - new Date(a.applied_date))

  const groupedApplicationRows = groupApplicationsByJob(
    filteredApplicationRows
  ).sort((a, b) => b.applied_job_id - a.applied_job_id)

  return (
    <Translation>
      {(t) => {
        return (
          <div className="container">
            <div className="row">
              <div className="dashboard-content-header">
                <h1></h1>
              </div>
            </div>

            <div className="row">
              <div className="dashboard-content-header">
                <div className="col-xs-12 col-sm-12 col-lg-12">
                  <ExpandablePanel
                    title={t('employer.app.h3')}
                    renderBody={() => (
                      <div className={classes.root}>
                        <ApplicationFilters
                          t={t}
                          filters={searchApplicationValues}
                          onChange={setSearchApplicationValues}
                          classes={classes}
                          statusOptions={statusOptions}
                          resetSelectedPage={() => setPage(0)}
                        />
                        <Table
                          className={classes.table}
                          aria-labelledby="tableTitle"
                          aria-label="enhanced table"
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell className={classes.tableHead}>
                                {t('employer.app.col1')}
                              </TableCell>
                              <TableCell className={classes.tableHead}>
                                {t('employer.app.col7')}
                              </TableCell>
                              <TableCell
                                className={classes.tableHead}
                                colSpan={2}
                              >
                                {t('employer.app.h1a')}
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {createApplicationRows(
                              t,
                              page,
                              searchApplicationValues.pageSize,
                              groupedApplicationRows
                            )}
                          </TableBody>
                        </Table>
                        <Divider />
                        <div className="panel-body">
                          {groupedApplicationRows.length > 0 ? (
                            <ReactPaginate
                              previousLabel={
                                <i className="fa fa-chevron-left" />
                              }
                              nextLabel={<i className="fa fa-chevron-right" />}
                              breakLabel={'...'}
                              breakClassName={'break-me'}
                              pageCount={
                                !!groupedApplicationRows
                                  ? Math.ceil(
                                      groupedApplicationRows.length /
                                        searchApplicationValues.pageSize
                                    )
                                  : 0
                              }
                              marginPagesDisplayed={2}
                              pageRangeDisplayed={5}
                              onPageChange={(event) => {
                                setPage(event.selected)
                              }}
                              containerClassName={'pagination'}
                              subContainerClassName={'pages pagination'}
                              activeClassName={'active'}
                              forcePage={page}
                            />
                          ) : (
                            <div style={{ padding: '20px' }}></div>
                          )}
                        </div>
                      </div>
                    )}
                    defaultExpanded={true}
                  />
                </div>
              </div>
            </div>
          </div>
        )
      }}
    </Translation>
  )
}

const createApplicationRows = (t, selected, pageSize, applicationsRows) => {
  return applicationsRows
    .slice(selected * pageSize, selected * pageSize + pageSize)
    .map((el, index) => (
      <ApplicationRowContainer
        t={t}
        index={index}
        application={el}
        key={el.applied_job_id}
      />
    ))
}

ApplicationsComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(ApplicationsComponent)
